import { ChangeDetectorRef, Component } from '@angular/core';
import { BaseFormComponent } from '../base-form/base-form.component';
import { TranslateService } from '@ngx-translate/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-landing-settings-form',
  templateUrl: './landing-settings-form.component.html',
  styleUrls: ['./landing-settings-form.component.scss'],
})
export class LandingSettingsFormComponent extends BaseFormComponent {
  constructor(translator: TranslateService, changeDetection: ChangeDetectorRef, formBuilder: UntypedFormBuilder) {
    super(
      translator,
      changeDetection,
      formBuilder.group({
        presentation: [false, Validators.required],
      })
    );
  }
}
